import { isRecruiterLiteData, isSalesNavData } from "shared-types";
const LINKEDIN_PROFILE_BASE_URL = "https://www.linkedin.com/in/";
/**
 * The readable profile link Airscale returned (linkedin.com/in/jane-doe) when the profile was fetched; otherwise the
 * link built from the LinkedIn ID, which LinkedIn also opens and redirects to the readable one.
 */
const getLinkedInProfileUrl = (candidate) => {
    var _a;
    const profile = candidate.linkedInApiProfile;
    if ((_a = profile === null || profile === void 0 ? void 0 : profile.url) === null || _a === void 0 ? void 0 : _a.includes("linkedin.com/in/"))
        return profile.url;
    if (profile === null || profile === void 0 ? void 0 : profile.identifier)
        return `${LINKEDIN_PROFILE_BASE_URL}${profile.identifier}`;
    return candidate.linkedInId ? `${LINKEDIN_PROFILE_BASE_URL}${candidate.linkedInId}` : "";
};
export const exportCandidatesToCSV = (candidates, filename = "candidates.csv") => {
    const headers = [
        "Name",
        "First Name",
        "Last Name",
        "Work Email",
        "Work Email Status",
        "Personal Email",
        "Personal Email Status",
        "Phone",
        "Headline",
        "Location",
        "Ready For Change",
        "Skills",
        "Degree Type",
        "Field of Study",
        "Years in Current Company",
        "Years in Current Position",
        "Year of Graduation",
        "Spoken Languages",
        "LinkedIn URL",
        "Company Name",
        "Role Experience",
        "Company Experience",
        "Industry",
        "Job Experiences",
        "Education Experiences",
        "Interest",
    ];
    const csvData = candidates.map((candidate) => {
        var _a, _b, _c, _d, _e;
        const externalData = candidate.externalData;
        const companyName = isSalesNavData(externalData) ? externalData.companyName || "" : "";
        const roleExperience = isSalesNavData(externalData) ? externalData.roleExperience || "" : "";
        const companyExperience = isSalesNavData(externalData) ? externalData.companyExperience || "" : "";
        const industry = isRecruiterLiteData(externalData) ? externalData.industry || "" : "";
        const jobExperiences = isRecruiterLiteData(externalData) ? externalData.jobExperiences || "" : "";
        const educationExperiences = isRecruiterLiteData(externalData) ? externalData.educationExperiences || "" : "";
        const interest = isRecruiterLiteData(externalData) ? externalData.interest || "" : "";
        const location = (externalData === null || externalData === void 0 ? void 0 : externalData.location) || "";
        return [
            (externalData === null || externalData === void 0 ? void 0 : externalData.name) || candidate.name || "",
            candidate.firstname || "",
            candidate.lastname || "",
            candidate.email || "",
            candidate.emailStatus || "",
            candidate.personalEmail || "",
            candidate.personalEmailStatus || "",
            candidate.phone || "",
            (externalData === null || externalData === void 0 ? void 0 : externalData.headline) || candidate.headline || "",
            location,
            getOpenToWorkStatus(candidate.openToWork),
            ((_a = candidate.skills) === null || _a === void 0 ? void 0 : _a.join("; ")) || "",
            ((_b = candidate.degreeType) === null || _b === void 0 ? void 0 : _b.join("; ")) || "",
            ((_c = candidate.fieldOfStudy) === null || _c === void 0 ? void 0 : _c.join("; ")) || "",
            candidate.yearsInCurrentCompany || "",
            candidate.yearsInCurrentPosition || "",
            ((_d = candidate.yearOfGraduation) === null || _d === void 0 ? void 0 : _d.join("; ")) || "",
            ((_e = candidate.spokenLanguages) === null || _e === void 0 ? void 0 : _e.map((lang) => `${lang.name} (${lang.proficiency})`).join("; ")) || "",
            getLinkedInProfileUrl(candidate),
            companyName,
            roleExperience,
            companyExperience,
            industry,
            jobExperiences,
            educationExperiences,
            interest,
        ];
    });
    const csvContent = [headers, ...csvData]
        .map((row) => row.map((field) => `"${String(field).replace(/"/g, '""')}"`).join(","))
        .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
// Exporting from an Open To Work search is the only thing that sets this now, and it only ever
// writes "true". Every other value means the same thing — nobody has established the person is
// ready for a change — including the "false" and the never-cleared "processing" that the retired
// enrichment left behind on records it never finished.
const getOpenToWorkStatus = (openToWork) => (openToWork === "true" ? "Ready for Change" : "Unknown");
